import {mainQuery} from '@github-ui/react-core/future/main-query'

import {orgReposListAppBuilder} from '../config/app-builder'
import type {PagePayload} from '../types'

export const orgReposPageRoute = orgReposListAppBuilder.createQueryRouteConfig('orgReposPageRoute', {
  path: '/orgs/:org/repositories',
  queries: [mainQuery<PagePayload>()],
})
